import React from 'react';

interface Props {
  value: number; // 0-100
  width?: number; // px, default 80
  showLabel?: boolean;
}

const ProgressBar = ({ value, width = 80, showLabel = true }: Props) => {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className="row" style={{ gap: 8 }}>
      <div className="prog" style={{ width }}>
        <span style={{ width: `${clamped}%` }} />
      </div>
      {showLabel && (
        <span className="mono" style={{ fontSize: 11.5, color: 'var(--ink-3)' }}>
          {clamped}%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
